import axios from "axios";
import store from "../store/state";

const customerUrl = store.envConfigs[(process.env.ENV_CONFIG || "stageQqs")].customerUrl;
let kefuService = axios.create({
  timeout: 10000,
  baseURL: customerUrl
});
// 请求超时10s
// axios.defaults.timeout = 10000;
// axios.defaults.baseURL = customerUrl;
let strToken = "token_customer_" + (process.env.ENV_CONFIG || "stageQqs");

//http request 拦截器
kefuService.interceptors.request.use(
  config => {
    let token = localStorage && localStorage.getItem(strToken);
    token && (config.headers.Authorization = token);
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//http response 拦截器
kefuService.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录
        // 未登录则跳转登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，这一步需要在登录页操作。
        case 401:
          // router.replace({
          //     path: '/login',
          //     query: {
          //         redirect: router.currentRoute.fullPath
          //     }
          // });
          break;
        // 403 token过期
        // 登录过期对用户进行提示
        // 清除本地token和清空vuex中token对象
        // 跳转登录页面
        case 403:
          // Toast({
          //     message: '登录过期，请重新登录',
          //     duration: 1000,
          //     forbidClick: true
          // });
          // 清除token
          // localStorage.removeItem('token');
          // store.commit('loginSuccess', null);
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          // setTimeout(() => {
          //     router.replace({
          //         path: '/login',
          //         query: {
          //             redirect: router.currentRoute.fullPath
          //         }
          //     });
          // }, 1000);
          break;
        // 404请求不存在
        case 404:
          // Toast({
          //     message: '网络请求不存在',
          //     duration: 1500,
          //     forbidClick: true
          // });
          break;
        // 其他错误，直接抛出错误提示
        default:
        // Toast({
        //     message: error.response.data.message,
        //     duration: 1500,
        //     forbidClick: true
        // });
      }
      return Promise.reject(error.response);
    }
  }
);

export function get(url, params) {
  return new Promise((resolve, reject) => {
    kefuService
      .get(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function post(url, params) {
  return new Promise((resolve, reject) => {
    kefuService
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

const qqsAxios = axios.create();
const qqsUrl = store.envConfigs[(process.env.ENV_CONFIG || "stageQqs")].baceUrl;
const qqsToken = store.envConfigs[(process.env.ENV_CONFIG || "stageQqs")].adminToken;
qqsAxios.defaults.baseURL = qqsUrl;

qqsAxios.interceptors.request.use(
  config => {
    let token = localStorage && localStorage.getItem(strToken);
    token && (config.headers.Authorization = qqsToken);
    return config;
  },
  error => {
    return Promise.error(error);
  }
);
export function qqsPost(url, params) {
  return new Promise((resolve, reject) => {
    qqsAxios
      .post(url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/http/http.js